// @flow
import * as React from 'react';
import {
  GenderView,
  Portal, Tobacco,
  useAgentByIdQuery
} from '../../../../../shared';
import moment from 'moment/moment';
import { getUserName } from '@coverright/utils';
import { formatToPhoneNumber } from '@coverright/ui/inputs';
import { StyledRecord } from './styled-record';
import { Divider, Typography } from '@mui/material';
import { withButton } from '../../../../../features';
import { useMedigapCompanyQuery } from '@coverright/data-access/types/medigap';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';
import { MgEnrollmentEditButton } from './mg-enrollment-form';
import { getMgEnrollmentTypeSubTitle, getMgEnrollmentTypeTitle } from '../lib';
import { EnrollmentListItemOutput, MedigapEnrollmentType } from '@coverright/data-access/types/enrollment';

type Props = {
  enrollment: EnrollmentListItemOutput;
  onChange: () => void,
};
export const Card = ({enrollment}: Props) => {
  const {data} = useAgentByIdQuery({
    variables: {
      id: enrollment.agentId
    },
    skip: !enrollment.agentId
  })

  const {data: companyData} = useMedigapCompanyQuery({
    client: mainBackendApolloClient,
    variables: { naic: enrollment.naic! },
    skip: !enrollment.naic
  })

  const carrier = companyData?.medigapCompany?.name;
  const parent = companyData?.medigapCompany?.parentCompanyName;

  const agent = data?.agentById ? getUserName(data?.agentById) : '';

  const location = `${enrollment.zip} ${enrollment.county}`

  return (
    <Portal sx={{p: 1, alignSelf: 'stretch', mb: 2}}>
      <Typography align={'center'} variant={'body2'} sx={{lineHeight: 1, bgcolor: '#E0F0F5', mx: -1, mt: -1, mb: 1, p: 1, fontWeight: 500}}>
        Medicare Supplement
      </Typography>
      <StyledRecord title={'Name'} value={getUserName(enrollment)} />
      <StyledRecord title={'Email'} tooltip={enrollment.email} value={enrollment.email} />
      <StyledRecord title={'Phone'} value={formatToPhoneNumber(enrollment.phoneNumber)} />
      <StyledRecord title={'Birth date'} value={`${moment.utc(enrollment.birthDate).format('MM/DD/YYYY')}`} />
      {enrollment.age && <StyledRecord title={'Age'} value={enrollment.age} />}
      <StyledRecord title={'Tobacco'} value={<Tobacco value={enrollment.tobacco} />} />
      {enrollment.gender && <StyledRecord title={'Gender'} value={<GenderView value={enrollment.gender} />} />}
      <StyledRecord title={'Location'} value={location} />
      <Divider sx={{my: 1, mx: -1}} />
      {enrollment.mgPlanName && <StyledRecord title={'Plan'} value={'Plan ' + enrollment.mgPlanName} />}
      {enrollment.effectiveDate && <StyledRecord title={'Effective date'} value={`${moment.utc(enrollment.effectiveDate).format('MM/DD/YYYY')}`} />}
      {enrollment.started && <StyledRecord title={'Started'} value={`${moment.utc(enrollment.started).format('MM/DD/YYYY')}`} />}
      {enrollment.approvedAt && <StyledRecord title={'Approved'} value={`${moment.utc(enrollment.approvedAt).format('MM/DD/YYYY')}`} />}
      {parent && <StyledRecord title={'Parent carrier'} tooltip={parent} value={parent} />}
      {carrier && <StyledRecord title={'Carrier'} tooltip={carrier} value={carrier} />}
      {enrollment.agentId && <StyledRecord title={'Writing agent'} value={agent} />}
      {false && enrollment.status && <StyledRecord title={'Status'} sx={{'& .record-value': {color: 'warning.500'}}} value={enrollment.status} />}
      {enrollment.enrollmentType && <StyledRecord title={'Type'}
                                                  tooltip={getMgEnrollmentTypeSubTitle(enrollment.enrollmentType as MedigapEnrollmentType)}
                                                  value={getMgEnrollmentTypeTitle(enrollment.enrollmentType as MedigapEnrollmentType)} />}
    </Portal>
  );
};

export const MgEnrollment = withButton(
  Card,
  MgEnrollmentEditButton
)
